<h4>{{ 'externalOrderDetails.externalOrderDetails' | transloco }}</h4>
@if (isLockedByMe) {
  <div>
    <div class="flex-container">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{ 'externalOrderDetails.externalNumber' | transloco }}</mat-label>
        <input matInput name="externalNumber" [(ngModel)]="this.externalOrderNumber!.number"
          [placeholder]="'externalOrderDetails.externalNumber' | transloco">
      </mat-form-field>
    </div>
    <div class="flex-container">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{ 'externalOrderDetails.additionalField' | transloco }}</mat-label>
        <input matInput name="additionalField1" [(ngModel)]="this.externalOrderNumber!.additionalField1"
          [placeholder]="'externalOrderDetails.additionalField' | transloco">
      </mat-form-field>
    </div>
    <div class="flex-container">
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>{{ 'externalOrderDetails.dateReceived' | transloco }}</mat-label>
        <input matInput [matDatepicker]="dateReceived" [(ngModel)]="this.externalOrderNumber!.dateReceived"
          [placeholder]="'common.labels.yyyyMmDd' | transloco">
        <mat-datepicker-toggle matSuffix [for]="dateReceived"></mat-datepicker-toggle>
        <mat-datepicker #dateReceived></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="flex-container">
      <button mat-raised-button (click)="saveExternalOrderNumber()" color="primary"
        class="padding-sides flex-item form-field" [attr.aria-label]="'externalOrderDetails.saveExternalOrderNumber' | transloco">
        {{ 'common.buttons.save' | transloco }}
      </button>
    </div>
  </div>
} @else {
  @if (showExternalDetails()) {
    <div class="flex-container">
      <span class="flex-item">{{ 'externalOrderDetails.externalNumber2' | transloco }}</span>
      <span class="flex-item-2">{{ externalOrderNumber!.number }}</span>
    </div>
  }
  @if (showExternalDetails()) {
    <div class="flex-container">
      <span class="flex-item">{{ 'externalOrderDetails.additionalField2' | transloco }}</span>
      <span class="flex-item-2">{{ externalOrderNumber!.additionalField1 }}</span>
    </div>
  }
  @if (showExternalDetails()) {
    <div class="flex-container">
      <span class="flex-item">{{ 'externalOrderDetails.dateReceived2' | transloco }}</span>
      <span class="flex-item-2">{{ externalOrderNumber!.dateReceived | localizedDate:'yyyy-MM-dd HH:mm' }}</span>
    </div>
  }
}
